import { InjectionToken, IterableDifferFactory } from '@angular/core';

export const ITERABLE_DIFFER_FACTORIES = new InjectionToken<IterableDifferFactory[]>('ITERABLE_DIFFER_FACTORIES');
